import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/feature/Reveal";

export default function LatestReviews() {
  const latest = topics.slice(0, 6);

  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="持续更新中"
            title="最新复盘"
            desc="每篇都从时间线开始，把材料、分歧点与结论分开写清楚，读完能自己判断。"
          />
          <Link
            to="/topics"
            className="inline-flex shrink-0 cursor-pointer items-center gap-1.5 self-start whitespace-nowrap rounded-md bg-foreground-900 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-950 md:self-auto"
          >
            查看全部 {topics.length} 篇
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </span>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {latest.map((topic, index) => (
            <Reveal key={topic.id} delay={index * 60}>
              <TopicCard topic={topic} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}